import { computed } from 'vue';
import ChevronIcon from '../../icons/arrows/component-lib.esm2.js';
import FlexSpacer from '../flex-spacer/component-lib.esm.js';
import { getThemeColor, getTextColor } from '../../styles/theme/component-lib.esm3.js';
import { useTheme } from '../../compositions/component-lib.esm7.js';

//
var script = {
  name: 'AccordionItem',
  components: {
    FlexSpacer,
    ChevronIcon
  },
  props: {
    title: {
      type: String,
      required: true
    },
    color: {
      type: String,
      default: 'primary'
    },
    variant: {
      type: String,
      default: null,
      validator: value => {
        return [null, 'outline'].includes(value);
      }
    }
  },
  setup(props) {
    const theme = useTheme();
    const styles = computed(() => {
      const bgColor = getThemeColor(props.color, theme.value);
      const color = getTextColor(props.color, theme.value);
      return {
        '--c-color': color,
        '--c-bg-color': bgColor
      };
    });
    const classes = computed(() => {
      return {
        [`accordion-item--${props.variant}`]: props.variant
      };
    });
    return {
      styles,
      classes
    };
  }
};
export { script as default };